import { render, staticRenderFns } from "./AsideLogo.vue?vue&type=template&id=868321f2&scoped=true&"
import script from "./AsideLogo.vue?vue&type=script&lang=js&"
export * from "./AsideLogo.vue?vue&type=script&lang=js&"
import style0 from "./AsideLogo.vue?vue&type=style&index=0&id=868321f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868321f2",
  null
  
)

export default component.exports